module.exports = __webpack_public_path__ + "static/media/Flecha_abajo.9d4040c0.png";